export default function ($scope, $anchorScroll, AuthenticationService, FlashService, Restangular, progression, $location) {


    $scope.$watch('plainPassword', function(){
        $scope.form.plainPassword.$setValidity('low', true);
    });

    $scope.$watch('confirm', function(){
        $scope.form.confirm.$setValidity('same', true);
    });

    $scope.$watch('old', function(){
        $scope.form.old.$setValidity('not', true);
    });

    $scope.register = function () {
        $scope.dataLoading = true;
        progression.start();

        let user = {
            old: $scope.old,
            plainPassword : $scope.plainPassword,
            confirm: $scope.confirm
        };

        Restangular
            .all('user/change-password')
            .patch(user)
            .then(data => {

                $location.path('/account');

                FlashService.Success("PROFILE_UPDATE");
                progression.done();

                $scope.dataLoading = false;
            }, error => {
                $scope.dataLoading = false;

                $anchorScroll("body");
                FlashService.Error("MALFORMET_DATA");
                progression.done()

                error.data.fields.forEach(function(field, index){
                    if(field.property_path == 'plainPassword'){
                        $scope.form[field.property_path].$setValidity('low', false);
                    }

                    if(field.property_path == 'confirm'){
                        $scope.form[field.property_path].$setValidity('same', false);
                    }

                    if(field.property_path == 'old'){
                        $scope.form[field.property_path].$setValidity('not', false);
                    }
                });

                form.$invalid = false;

            });

    };
};


/** WEBPACK FOOTER **
 ** ./js/theme/change-password/controller.js
 **/